export enum ShelfSceneHacksPickerTabEnum {
  SHELF = 'shelf',
  SCENE = 'scene',
  HACKS = 'hacks',
}
